import { AgentAssociationMigrationBatchStatus, AgentAssociationMigrationUserStatus } from '@repo/database/src/types';
import { Type } from 'class-transformer';
import { ArrayNotEmpty, IsArray, IsDateString, IsEnum, IsOptional, IsString, IsUUID } from 'class-validator';

import { PaginationOptionsDto } from '../../pagination-options-types';

export class CreateAgentAssociationMigrationDto {
  @IsOptional()
  @IsUUID('4')
  sourceAgentId?: string | null;

  @IsOptional()
  @IsUUID('4')
  destinationAgentId?: string | null;

  @IsArray()
  @ArrayNotEmpty()
  @IsUUID('4', { each: true })
  userIds: string[];
}

export class CreateAgentAssociationMigrationResponseDto {
  batchId: string;
  effectiveFrom: string;
}

export class GetAgentAssociationMigrationBatchesDto extends PaginationOptionsDto {
  @IsOptional()
  @IsEnum(AgentAssociationMigrationBatchStatus)
  status?: AgentAssociationMigrationBatchStatus;

  @IsOptional()
  @IsDateString()
  from?: string;

  @IsOptional()
  @IsDateString()
  to?: string;

  @IsOptional()
  @IsUUID('4')
  sourceAgentId?: string;

  @IsOptional()
  @IsUUID('4')
  destinationAgentId?: string;
}

export class AgentAssociationMigrationBatchListItemDto {
  id: string;
  effectiveFrom: string;
  status: AgentAssociationMigrationBatchStatus;
  processedAt: string | null;
  createdAt: string;

  sourceAgent: { id: string; alias: string; email: string } | null;
  destinationAgent: { id: string; alias: string; email: string } | null;

  selectedRootUsersCount: number;
  selectedRootUserAliases: string[];
}

export class AgentAssociationMigrationBatchListResponseDto {
  items: AgentAssociationMigrationBatchListItemDto[];
  totalCount: number;
}

export class AgentAssociationMigrationUserDto {
  userId: string;
  alias: string;
  email: string;
  isAgent: boolean;
  status: AgentAssociationMigrationUserStatus;
  processedAt: string | null;
  error: string | null;
}

export class AgentAssociationMigrationBatchDetailDto {
  id: string;
  effectiveFrom: string;
  status: AgentAssociationMigrationBatchStatus;
  processedAt: string | null;
  createdAt: string;
  error: string | null;

  sourceAgent: { id: string; alias: string; email: string } | null;
  destinationAgent: { id: string; alias: string; email: string } | null;

  createdByUser: { id: string; alias: string; email: string };

  @Type(() => AgentAssociationMigrationUserDto)
  selectedRootUsers: AgentAssociationMigrationUserDto[];
}

export interface MigrationVerificationUserTree {
  userId: string;
  alias: string;
  isRootUser: boolean;
  isReferralQualified: boolean;
  beforeDepth: number;
  expectedDepth: number;
  actualDepth: number;
  depthPassed: boolean;
  beforeAgreementId: string | null;
  expectedAgreementId: string | null;
  actualAgreementId: string | null;
  agreementPassed: boolean;
  referralHistoryCount: number;
  historyPassed: boolean;
  children: MigrationVerificationUserTree[];
}

export interface MigrationVerificationDto {
  batchId: string;
  effectiveFrom: string;
  status: AgentAssociationMigrationBatchStatus;

  sourceAgent: { id: string; alias: string; referrerCode: string; depth: number } | null;
  destinationAgent: { id: string; alias: string; referrerCode: string; depth: number } | null;

  depthDelta: number;

  migratedUsers: MigrationVerificationUserTree[];

  summary: {
    totalUsersInSubtrees: number;
    passedCount: number;
    failedCount: number;
    allPassed: boolean;
  };
}

export class SearchUsersByAliasesDto {
  @IsArray()
  @ArrayNotEmpty()
  @IsString({ each: true })
  aliases: string[];
}

export interface SearchUserForMigrationDto {
  id: string;
  alias: string;
  email: string;
  isAgent: boolean;
  referralDepth: number;
  currentAgent: { id: string; alias: string } | null;
}

export interface SearchUsersByAliasesResponseDto {
  found: SearchUserForMigrationDto[];
  notFound: string[];
}
